import React, { Component } from "react";
import PropTypes from "prop-types";
import { Container, Divider, Sticky, Ref, Grid } from "semantic-ui-react";
import { Error } from "@components/Error";
import { Loader } from "@components/Loader";
import { SpecialCollectionHeader } from "./SpecialCollectionHeader";
// import { SpecialCollectionSummary } from './SpecialCollectionSummary';
import { SpecialCollectionMetadata } from "./SpecialCollectionMetadata";
// import { SpecialCollectionContent } from './SpecialCollectionContent';
import { SpecialCollectionActionMenu } from "./SpecialCollectionActionMenu";

export class SpecialCollectionDetails extends Component {
  constructor(props) {
    super(props);
    this.menuRef = React.createRef();
    this.headerRef = React.createRef();

    this.anchors = {
      summaryRef: React.createRef(),
      metadataRef: React.createRef(),
      contentRef: React.createRef(),
      statisticsRef: React.createRef(),
    };
  }

  componentDidMount() {
    const { fetchSpecialCollectionDetails, match } = this.props;
    fetchSpecialCollectionDetails(match.params.specialCollectionPid);
  }

  componentDidUpdate(prevProps) {
    const { fetchSpecialCollectionDetails, match } = this.props;

    const specialCollectionPid = match.params.specialCollectionPid;
    const samePidFromRouter =
      prevProps.match.params.specialCollectionPid === specialCollectionPid;
    if (!samePidFromRouter) {
      fetchSpecialCollectionDetails(specialCollectionPid);
    }
  }

  render() {
    const { isLoading, error, data } = this.props;

    return (
      <div ref={this.headerRef}>
        <Container fluid>
          <Loader isLoading={isLoading}>
            <Error error={error}>
              <Sticky context={this.headerRef} className="solid-background">
                <Container fluid className="spaced">
                  <SpecialCollectionHeader data={data} />
                </Container>
                <Divider />
              </Sticky>
              <Container fluid>
                <Ref innerRef={this.menuRef}>
                  <Grid columns={2}>
                    <Grid.Column width={13}>
                      <Container className="spaced">
                        {/* <Container className="spaced">
                          <div
                            ref={this.anchors.summaryRef}
                            id="special-collection-summary"
                          >
                            <SpecialCollectionSummary
                              anchors={this.anchors}
                              specialCollection={data}
                            />
                          </div>
                        </Container> */}
                        <SpecialCollectionMetadata
                          anchors={this.anchors}
                          data={data}
                        />
                        {/* <SpecialCollectionContent
                          anchors={this.anchors}
                          data={data}
                        /> */}
                      </Container>
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Sticky context={this.menuRef} offset={200}>
                        <SpecialCollectionActionMenu
                          offset={-250}
                          data={data}
                        />
                      </Sticky>
                    </Grid.Column>
                  </Grid>
                </Ref>
              </Container>
            </Error>
          </Loader>
        </Container>
      </div>
    );
  }
}

SpecialCollectionDetails.propTypes = {
  // Redux
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  data: PropTypes.object.isRequired,
  // hasError: PropTypes.bool.isRequired,
  fetchSpecialCollectionDetails: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      specialCollectionPid: PropTypes.string,
    }),
  }).isRequired,
};

SpecialCollectionDetails.defaultProps = {
  error: null,
};
export default SpecialCollectionDetails;
